import SignInSession from "../storage/SignInSession";
import SecretKey from '../secret/SecretKey';
import CryptoJS, { AES } from 'crypto-js';

const apiService = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    /**
     * 要最基本的資料 api的連結、token
     * */
    base: function (call) {

        SignInSession.get_Secret(function (user_Session) {

            fetch(apiService.baseUrl + 'base', {
                method: 'POST',
                crossDomain: true,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(res => res.json())
                .then(data => {
                    call(data, user_Session??'');
                })
                .catch(e => {

                })
        });
    },
    /**
     * 呼叫API
     * @param {string} path_name api名稱(不需要含Controller)
     * @param {option} data 傳送的data 
     * @param {function} call 回傳function
     */
    call: function (path_name, res_data, call) {
        var body = JSON.stringify(res_data);

        apiService.base(function (data, user_Session) {
            var url = data.api + path_name;

            fetch(url, {
                method: 'POST',
                crossDomain: true,
                headers: {
                    'Content-Type': "application/json",
                    'Authorization': data.token,
                    'SmmAuthorization': user_Session
                },
                body: body
            })
                .then(res => res.json())
                .then(message => {
                    call(message);
                })
                .catch(e => {
                    console.log(e);
                })
        });
    },
    /**
    * 呼叫API
    * @param {string} path_name api名稱(不需要含Controller)
    * @param {option} data 傳送的data 
    * @param {function} call 回傳function
    */
    FormData_call: function (path_name, data, call) {
        var body = data;

        apiService.base(function (data, user_Session) {
            var url = data.api + path_name;

            fetch(url, {
                method: 'POST',
                crossDomain: true,
                headers: {

                    'Authorization': data.token,
                    'SmmAuthorization': user_Session
                },
                body: body
            })
                .then(res => res.json())
                .then(message => {
                    call(message);
                })
                .catch(e => {

                })
        });
    },
    /**
     * 不含Data
     * @param {any} path_name api名稱(不需要含Controller)
     * @param {any} call 回傳function
     */
    call2: function (path_name, call,errorcall) {

        apiService.base(function (data, user_Session) {
            var url = data.api + path_name;

            fetch(url, {
                method: 'POST',
                crossDomain: true,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data.token,
                    'SmmAuthorization': user_Session
                }
            })
                .then(res => res.json())
                .then(message => {
                    call(message);
                })
                .catch(e => {
                    if (errorcall != null) errorcall(e);
                })
        });
    },
    call_text: function (path_name, call, errorcall) {

        apiService.base(function (data, user_Session) {
            var url = data.api + path_name;

            fetch(url, {
                method: 'POST',
                crossDomain: true,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data.token,
                    'SmmAuthorization': user_Session
                }
            })
                .then(res => res.text())
                .then(message => {
                    call(message);
                })
                .catch(e => {
                    if (errorcall != null) errorcall(e);
                })
        });
    },

    /**
     * 首頁-最新消息-輪播
     * @param {any} call
     */
    get_ArticleQuantityTop5: function (call) {

        this.call2('get_ArticleQuantity/2/5', function (data) {
            call(data);
        });
    },

    /**
     * 呼叫報表- education = 1,history = 2,resources = 3,year = 4
     * @param {any} call
     */
    get_report: function (type, call) {

        this.call2('get_Recycle/' + type, function (data) {
            call(data);
        });
    },

    /**
     * 取得最新消息類別
     * @param {any} type cycle_news=1,news=2,seminar=3
     * @param {any} call
     */
    get_Article: function (type, call) {

        this.call2('get_Article/' + type, function (data) {
            call(data);
        });
    },

    /**
    * 研討會
    * @param {any} call
    */
    get_ArticleSeminar: function (call) {

        this.call2('get_Article/3', function (data) {
            call(data);
        });
    },

    get_RecycleSingle: function (Recycle_Guid, call) {
        this.call2('get_RecycleSingle/' + Recycle_Guid, function (data) {
            call(data);
        });
    },

    get_ArticleSingle: function (Article_Guid, call) {
        this.call2('get_ArticleSingle/' + Article_Guid, function (data) {
            call(data);
        });
    },
    /**
     * recaptcha 
     * @param {any} value 驗證
     */
    recaptcha: function (value, call) {
        var o = {
            RecaptchaCode: value
        }

        this.call('recaptcha', o, function (data) {
            call(data);
        });
    },
    /**
     * 登入
     * @param {any} act 帳號
     * @param {any} pwd 密碼
     * @param {any} call
     */
    signin: function (act, pwd, call) {
        var _SecretKey = SecretKey.Key;

        pwd = AES.encrypt(pwd, _SecretKey, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString();

        var models = {
            'account': act,
            'pwd': pwd
        }

        this.call('CirculationSignin', models, function (data) {
            call(data);
        });
    },

    /**
     * 新增文章
     * @param {any} ArticleTitle 主題
     * @param {any} ArticleCrTime 發佈日期
     * @param {any} ArticleContent 內容
     * @param {any} selectedFile 選擇的檔案
     */
    set_Article: function (ArticleGuid, ArticleTitle, ArticleCrTime, ArticleContent, ArticleType, selectedFile, call) {




        var e = this;
        SignInSession.get(function (models) {

            if (models != null) {

                const formData = new FormData();
                formData.append('ArticleGuid', ArticleGuid);
                formData.append('ArticleTitle', ArticleTitle);
                formData.append('ArticleCrTime', ArticleCrTime);
                formData.append('ArticleContent', ArticleContent);
                formData.append('ArticleType', ArticleType);
                formData.append('ArticleCrUser', models.userSecret);

                formData.append('Files', selectedFile);




                e.FormData_call('set_Article', formData, function (data) {
                    call(data);
                });
            } else {
                call('notLoggedIn');
            }
        });
    },

    /**
     * 刪除文章 
     * @param {any} Article_Guid 文章編號
     */
    del_Article: function (Article_Guid, call) {
        var e = this;
        SignInSession.get(function (models) {
            if (models != null) {
                e.call2('del_Article/' + Article_Guid, function (data) {
                    call(data);
                });
            } else {
                call('notLoggedIn');
            }
        });
    },

    /**
    * 新增循環經濟文章
    * @param {any} ArticleTitle 主題
    * @param {any} ArticleCrTime 發佈日期
    * @param {any} ArticleContent 內容
    * @param {any} selectedFile 選擇的檔案
    */
    set_Recycle: function (RecycleGuid, RecycleTitle, RecycleCrTime, RecycleOrder, RecycleType, selectedFile, call) {

        var e = this;
        SignInSession.get(function (models) {
            if (models != null) {
                const formData = new FormData();
                formData.append('RecycleGuid', RecycleGuid);
                formData.append('RecycleTitle', RecycleTitle);
                formData.append('RecycleCrTime', RecycleCrTime);
                formData.append('RecycleOrder', RecycleOrder);
                formData.append('RecycleType', RecycleType);
                formData.append('RecycleCrUser', models.userSecret);
                
                formData.append('Files', selectedFile);

                e.FormData_call('set_Recycle', formData, function (data) {
                    call(data);
                });
            } else {
                call('notLoggedIn');
            }
        });
    },

    set_RecycleForYotube: function (RecycleGuid, RecycleTitle, RecycleCrTime, RecycleOrder, RecycleType, RecycleFileName, call) {

        var e = this;
        SignInSession.get(function (models) {
            if (models != null) {
                const formData = new FormData();
                formData.append('RecycleGuid', RecycleGuid);
                formData.append('RecycleTitle', RecycleTitle);
                formData.append('RecycleCrTime', RecycleCrTime);
                formData.append('RecycleOrder', RecycleOrder);
                formData.append('RecycleType', RecycleType);
                formData.append('RecycleCrUser', models.userSecret);
                formData.append('RecycleFileName', RecycleFileName);
                formData.append('Files', null);

                e.FormData_call('set_Recycle', formData, function (data) {
                    call(data);
                });
            } else {
                call('notLoggedIn');
            }
        });
    },
    /**
  * 刪除循環經濟文章
  * @param {any} del_Recycle 文章編號
  */
    del_Recycle: function (del_Recycle, call) {

        this.call2('del_Recycle/' + del_Recycle, function (data) {
            call(data);
        });
    },

    getYoutube: function (youtube_id, call, error_call) {
        //this.call_text('getYoutube/' + youtube_id, function (data) {
        //    call(data);
        //}, error_call);
        var url = 'https://www.googleapis.com/youtube/v3/videos?part=snippet&id=' + youtube_id +'&fields=items(id,snippet)&key=AIzaSyD4dsnQ_scxMNllzoeDE06wJ9ZVktYeV0M'
        fetch(url, {
            method: 'GET',
            crossDomain: true,
            headers: {
                'Content-Type': "application/json"
            }
        })
            .then(res => res.json())
            .then(message => {
                call(message);
            })
            .catch(e => {
                console.log(e);
            })
    
    },
    /**
     * 取得瀏覽人數
     * */
    getViewers: function (call) {
        this.call2('viewers', function (data) {
            call(data);
        });
    },
    HotKeyword: {
        /**
         * 取得熱門關鍵字
         * @param {any} id
         * @param {any} call
         */
        get_HotKeyword: function (id, lang, call) {
            apiService.call2('HotKeywordList?id=' + id + '&lang=' + lang, function (data) {
                call(data);
            });
        },
        /**
         * 新增熱門關鍵字
         * @param {any} HkdKeyword 熱門關鍵字
         * @param {any} HkdOrder 排序
         */
        set_HotKeyword: function (HkdId, HkdKeyword, HkdOrder, HkdLang, call) {
            SignInSession.get(function (models) {
                if (models != null) {
                    const formData = new FormData();
                    formData.append('HkdId', HkdId);
                    formData.append('HkdKeyword', HkdKeyword);
                    formData.append('HkdOrder', HkdOrder);
                    formData.append('HkdLang', HkdLang);
                    formData.append('HkdCrUser', models.userSecret);
                    formData.append('HkdModifyUser', models.userSecret);
                    apiService.FormData_call('set_HotKeyword', formData, function (data) {
                        call(data);
                    });
                } else {
                    call('notLoggedIn');
                }
            });
        },

        /**
         * 刪除熱門關鍵字
         * @param {any} id 編號
         */
        del_HotKeyword: function (id, call) {
            SignInSession.get(function (models) {
                if (models != null) {
                    apiService.call2('del_HotKeyword/' + id, function (data) {
                        call(data);
                    });
                } else {
                    call('notLoggedIn');
                }
            });
        },
    },
}

export default apiService;